module.exports = __webpack_public_path__ + "static/media/mn22.18b39161.jpeg";